<div class="auth-root">

  <div class="auth-left">
    <div class="auth-left-inner">
      <ng-content></ng-content>

      <p class="auth-switch">
        @if (mode === 'signin') {
          Don't have an account? <a routerLink="/signup">Sign up here</a>
        } @else if (mode === 'signup') {
          Already have an account? <a routerLink="/signin">Sign in</a>
        } @else {
          <a routerLink="/signin">Back to sign in</a>
        }
      </p>
    </div>
  </div>

  <div class="auth-right">
    <div class="auth-scene" aria-hidden="true">
      <svg width="100%" height="100%" viewBox="0 0 800 900" preserveAspectRatio="xMidYMid meet">
        <defs>
          <radialGradient id="authGlow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stop-color="var(--auth-accent)" stop-opacity="0.35"></stop>
            <stop offset="100%" stop-color="var(--auth-accent)" stop-opacity="0"></stop>
          </radialGradient>
        </defs>

        <g data-float data-float-range="420,380">
          <circle cx="620" cy="220" r="220" fill="url(#authGlow)"></circle>
          <circle cx="620" cy="220" r="90" fill="none" stroke="var(--auth-accent)" stroke-width="1" opacity="0.4" class="auth-spin-fwd" style="transform-origin: 620px 220px;"></circle>
          <circle cx="620" cy="220" r="150" fill="none" stroke="var(--auth-accent)" stroke-width="0.75" opacity="0.22" class="auth-spin-rev" style="transform-origin: 620px 220px;"></circle>
        </g>

        <g data-float data-float-range="380,300">
          <circle cx="140" cy="700" r="180" fill="url(#authGlow)"></circle>
          <circle cx="140" cy="700" r="70" fill="none" stroke="var(--auth-accent)" stroke-width="1" opacity="0.3" class="auth-spin-rev-slow" style="transform-origin: 140px 700px;"></circle>
        </g>

        <text data-float data-float-range="340,280" x="420" y="560" class="auth-scene-label" opacity="0.12">SKU-2048</text>
        <text data-float data-float-range="340,280" x="560" y="700" class="auth-scene-label auth-scene-label-sm" opacity="0.12">GS1-128</text>

        <g data-float data-float-range="320,300" data-float-base="translate(600px,460px)" style="transform: translate(600px,460px);" opacity="0.16">
          <rect x="0" y="0" width="56" height="42" rx="4" fill="none" stroke="var(--auth-accent-300)" stroke-width="1.5"></rect>
          <circle cx="14" cy="14" r="4" fill="var(--auth-accent-300)"></circle>
          <path d="M4 34 L20 20 L32 30 L44 16 L52 34 Z" fill="var(--auth-accent-300)"></path>
        </g>
        <g data-float data-float-range="300,280" data-float-base="translate(130px,340px)" style="transform: translate(130px,340px);" opacity="0.13">
          <rect x="0" y="0" width="42" height="32" rx="3" fill="none" stroke="var(--auth-accent-300)" stroke-width="1.2"></rect>
          <circle cx="10" cy="9" r="3" fill="var(--auth-accent-300)"></circle>
          <path d="M3 26 L14 15 L22 22 L31 12 L38 26 Z" fill="var(--auth-accent-300)"></path>
        </g>

        <circle data-float data-float-range="260,220" data-float-base="translate(500px,120px)" style="transform: translate(500px,120px);" cx="0" cy="0" r="3" fill="var(--auth-accent-300)" opacity="0.6" class="auth-pulse"></circle>
        <circle data-float data-float-range="240,200" data-float-base="translate(720px,420px)" style="transform: translate(720px,420px);" cx="0" cy="0" r="2.5" fill="var(--auth-accent-300)" opacity="0.5" class="auth-pulse auth-pulse-delay-1"></circle>
        <circle data-float data-float-range="220,240" data-float-base="translate(60px,480px)" style="transform: translate(60px,480px);" cx="0" cy="0" r="3" fill="var(--auth-accent-300)" opacity="0.5" class="auth-pulse auth-pulse-delay-2"></circle>

        <line x1="0" y1="330" x2="800" y2="290" stroke="var(--auth-accent)" stroke-width="1" opacity="0.14" class="auth-drift"></line>
        <line x1="0" y1="560" x2="800" y2="610" stroke="var(--auth-accent)" stroke-width="1" opacity="0.1" class="auth-drift auth-drift-rev"></line>
        <line x1="240" y1="0" x2="290" y2="900" stroke="var(--auth-accent)" stroke-width="1" opacity="0.08" class="auth-drift"></line>

        <g data-float data-float-range="280,260" data-float-base="translate(560px,540px) rotate(-8deg)" style="transform: translate(560px,540px) rotate(-8deg);" opacity="0.4" class="auth-pulse-slow">
          <rect x="0" y="0" width="3" height="52" fill="var(--auth-accent-300)"></rect>
          <rect x="6" y="0" width="1.5" height="52" fill="var(--auth-accent-300)"></rect>
          <rect x="10" y="0" width="4" height="52" fill="var(--auth-accent-300)"></rect>
          <rect x="17" y="0" width="1.5" height="52" fill="var(--auth-accent-300)"></rect>
          <rect x="21" y="0" width="2.5" height="52" fill="var(--auth-accent-300)"></rect>
          <rect x="27" y="0" width="1.5" height="52" fill="var(--auth-accent-300)"></rect>
          <rect x="31" y="0" width="4" height="52" fill="var(--auth-accent-300)"></rect>
          <rect x="38" y="0" width="2" height="52" fill="var(--auth-accent-300)"></rect>
          <rect x="43" y="0" width="1.5" height="52" fill="var(--auth-accent-300)"></rect>
          <rect x="47" y="0" width="3" height="52" fill="var(--auth-accent-300)"></rect>
        </g>
        <g data-float data-float-range="260,240" data-float-base="translate(120px,180px) rotate(6deg)" style="transform: translate(120px,180px) rotate(6deg);" opacity="0.3" class="auth-pulse-slow auth-pulse-delay-2">
          <rect x="0" y="0" width="2.5" height="40" fill="var(--auth-accent-300)"></rect>
          <rect x="5" y="0" width="1.5" height="40" fill="var(--auth-accent-300)"></rect>
          <rect x="9" y="0" width="3.5" height="40" fill="var(--auth-accent-300)"></rect>
          <rect x="15" y="0" width="1.5" height="40" fill="var(--auth-accent-300)"></rect>
          <rect x="19" y="0" width="2" height="40" fill="var(--auth-accent-300)"></rect>
          <rect x="24" y="0" width="1.5" height="40" fill="var(--auth-accent-300)"></rect>
          <rect x="28" y="0" width="3.5" height="40" fill="var(--auth-accent-300)"></rect>
          <rect x="34" y="0" width="1.5" height="40" fill="var(--auth-accent-300)"></rect>
          <rect x="38" y="0" width="2.5" height="40" fill="var(--auth-accent-300)"></rect>
        </g>
      </svg>
    </div>

    <div class="auth-hero">
      <div class="auth-hero-main">
        <div class="auth-wordmark">bar<span>xui</span></div>
        <div class="auth-wordmark-rule"></div>
        <p class="auth-tagline">A comprehensive cloud based design and printing system for data driven labelling and documents.</p>
        <img class="auth-diagram" src="assets/home/barxui-cloud.png" alt="barxui system diagram">
      </div>
    </div>

    <!-- Decorative props that roam the whole panel, independent of the text layout above
         (#1742) - absolutely positioned so their drift isn't boxed in by flex flow. -->
    <div class="auth-floaters">
      <div class="auth-panel" aria-hidden="true" data-float data-float-range="240,280" data-float-base="rotate(4deg)"
        style="left: 72%; top: 10%;">
        <div class="auth-panel-title">Nutrition Facts</div>
        <div class="auth-panel-sub">8 servings per container</div>
        <div class="auth-panel-cal"><span>Calories</span><span>230</span></div>
        <div class="auth-panel-row"><span>Total Fat 8g</span><span>10%</span></div>
        <div class="auth-panel-row"><span>Sodium 160mg</span><span>7%</span></div>
        <div class="auth-panel-row"><span>Total Carb. 37g</span><span>13%</span></div>
        <div class="auth-panel-row auth-panel-row-last"><span>Protein 3g</span><span></span></div>
      </div>

      <a href="https://barxui.com" target="_blank" rel="noopener" class="auth-qr-link"
        data-float data-float-range="220,260" style="left: 8%; top: 76%;">
        <img src="assets/auth/barxui-qr.png" alt="QR code linking to barxui.com" class="auth-qr">
      </a>
    </div>
  </div>

</div>
